export enum ProductName {
  Sage = 'sage',
  Bankrate = 'bankrate',
  SageHomeLoans = 'sage-home-loans',
}
